if (!customElements.get('meu-header')) {
  class MeuHeader extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector('[data-toggle]');
      this.navInner = this.querySelector('[data-nav-inner]');
      this.menuLinks = Array.from(this.querySelectorAll('.meu-header__link, .meu-header__mobile-link, .meu-header__mobile-foot [data-locale-toggle]'));
      this.desktop = window.matchMedia('(min-width: 768px)');

      this.onToggle = () => this.setOpen(!this.classList.contains('is-open'));
      this.onKeydown = (event) => {
        if (event.key !== 'Escape') return;
        if (this.classList.contains('is-open')) {
          this.setOpen(false);
          this.toggleButton.focus();
        }
        this.closeLocales();
      };
      this.onDocumentClick = (event) => {
        if (!this.contains(event.target)) {
          this.setOpen(false);
          this.closeLocales();
        }
      };
      this.onResize = () => this.updateHeight();

      this.toggleButton.addEventListener('click', this.onToggle);
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocumentClick);
      window.addEventListener('resize', this.onResize);

      // "[ Shop all ]" under the pill opens the same menu as the "+". It hides once the menu
      // is open, so keyboard focus moves on to the "+" (which now closes it)
      this.shopAll = this.querySelector('[data-shop-all]');
      this.shopAll?.addEventListener('click', () => {
        this.setOpen(true);
        this.toggleButton.focus({ preventScroll: true });
      });

      this.querySelectorAll('a.meu-header__link, a.meu-header__mobile-link, .meu-header__sub-link').forEach((link) => {
        link.addEventListener('click', () => this.setOpen(false));
      });

      // SHOP opens the category list underneath
      this.shopToggles = Array.from(this.querySelectorAll('[data-shop-toggle]'));
      this.subLinks = Array.from(this.querySelectorAll('.meu-header__sub-link'));
      this.shopToggles.forEach((toggle) => {
        toggle.addEventListener('click', (event) => {
          event.stopPropagation();
          this.setShopOpen(!this.classList.contains('is-shop-open'), toggle);
        });
      });

      this.querySelectorAll('[data-locale]').forEach((locale) => {
        const trigger = locale.querySelector('[data-locale-toggle]');
        if (!locale.querySelector('[data-locale-options]')) return;
        trigger.addEventListener('click', (event) => {
          event.stopPropagation();
          const open = !locale.classList.contains('is-open');
          this.closeLocales();
          locale.classList.toggle('is-open', open);
          trigger.setAttribute('aria-expanded', String(open));
        });
      });

      this.updateHeight();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('click', this.onDocumentClick);
      window.removeEventListener('resize', this.onResize);
    }

    setOpen(open) {
      if (open && this.navInner) {
        // The desktop pill grows to exactly the width of its links
        this.style.setProperty('--meu-nav-w', `${this.navInner.scrollWidth}px`);
      }
      this.classList.toggle('is-open', open);
      this.toggleButton.setAttribute('aria-expanded', String(open));
      this.shopAll?.setAttribute('aria-expanded', String(open));
      this.menuLinks.forEach((link) => link.setAttribute('tabindex', open ? '0' : '-1'));
      if (!open) {
        this.closeLocales();
        this.setShopOpen(false);
      }
    }

    setShopOpen(open, toggle) {
      if (open && toggle && this.desktop.matches) {
        // Line the desktop panel up under the SHOP link
        const panelPadding = 14;
        this.style.setProperty('--meu-sub-x', `${Math.round(toggle.getBoundingClientRect().left) - panelPadding}px`);
      }
      this.classList.toggle('is-shop-open', open);
      this.shopToggles?.forEach((button) => button.setAttribute('aria-expanded', String(open)));
      this.subLinks?.forEach((link) => link.setAttribute('tabindex', open ? '0' : '-1'));
    }

    closeLocales() {
      this.querySelectorAll('[data-locale].is-open').forEach((locale) => {
        locale.classList.remove('is-open');
        locale.querySelector('[data-locale-toggle]')?.setAttribute('aria-expanded', 'false');
      });
    }

    // Other theme parts (e.g. sticky product images) read --header-height
    updateHeight() {
      document.documentElement.style.setProperty('--header-height', this.desktop.matches ? '100px' : '72px');
    }
  }

  customElements.define('meu-header', MeuHeader);
}
